module.exports = __webpack_public_path__ + "media/images/ninestars/clients/client-4-937b91543dd383522523f5a2fca452f0.png";